<template>
  <div>
    <mdb-container class="mt-5 mb-5 p-4" style="background-color:#FFFFFF;">
      <mdb-row>
        <mdb-col col="9">
          <mdb-container>
            <mdb-row v-for="item in newsItems" v-bind:key="item.nameTag">
              <mdb-col>
                <mdb-row>
                  <mdb-col lg="5" xl="4">
                    <mdb-view hover class="rounded z-depth-1-half mb-lg-0 mb-4">
                      <img class="img-fluid" v-bind:src="item.playImg" />
                      <a>
                        <mdb-mask overlay="white-slight" waves />
                      </a>
                    </mdb-view>
                  </mdb-col>
                  <mdb-col lg="7" xl="8">
                    <h3 class="font-weight-bold mb-3 p-0">
                      <strong>{{item.nameShow}}</strong>
                    </h3>
                    <p class="dark-grey-text">{{item.desc}}</p>
                    <p class="author">Yunbu Innovation, {{item.date}}</p>
                    <mdb-btn color="default" size="sm" @click="gotoDetail(item.nameTag)">MORE</mdb-btn>
                  </mdb-col>
                </mdb-row>
                <hr class="my-3" />
              </mdb-col>
            </mdb-row>
          </mdb-container>
        </mdb-col>
        <mdb-col col="3">
          <h3 class="font-weight-bold mb-3 p-0">
            <strong>Top5</strong>
          </h3>
          <mdb-list-group>
            <mdb-list-group-item v-for="item in topItems" v-bind:key="item.nameTag">
              <mdb-row>
                <mdb-col md="4">
                  <mdb-view hover rounded class="z-depth-1-half mb-4">
                    <img class="img-fluid" v-bind:src="item.icon" @click="gotoDetail(item.nameTag)" />
                  </mdb-view>
                </mdb-col>
                <mdb-col md="8">
                  <p class="font-weight-bold dark-grey-text">
                    <a @click="gotoDetail(item.nameTag)">{{item.nameShow}}</a>
                  </p>
                </mdb-col>
              </mdb-row>
            </mdb-list-group-item>
          </mdb-list-group>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbBtn,
  mdbMask,
  mdbView,
  mdbListGroup,
  mdbListGroupItem
} from "mdbvue";
export default {
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbMask,
    mdbView,
    mdbBtn,
    mdbListGroup,
    mdbListGroupItem
  },
  data() {
    return {
      name: "News",
      news: [
        "lionandmouse",
        "catstory",
        "circlebreak",
        "crazycandybomb",
        "fishcrushcharminocean",
        "jewelsmaniacrush",
        "coloringcreative",
        "candyprincess",
        "sweetcandyforest"
      ],
      newsItems: [],
      tops: [
        "coloringcreative",
        "circlebreak",
        "lionandmouse",
        "catstory",
        "jewelsmaniacrush"
      ],
      topItems: []
    };
  },
  methods: {
    gotoDetail: function(nameTag) {
      this.$router.push({
        path: "detail",
        query: { name: nameTag }
      });
    }
  },
  computed: { ...mapGetters(["getGameByName"]) },
  created: function() {
    this.newsItems = this.getGameByName(this.news);
    this.topItems = this.getGameByName(this.tops);
  }
};
</script>
<style>
.author {
  background-color: #f0f3f5;
  font-size: 12px;
  font-weight: normal;
  color: #4f5e62;
  line-height: 1.42857143;
}
</style>